import React from 'react';

export const UploadIcon = (props) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    width="78"
    height="75"
    viewBox="0 0 78 75"
  >
    <defs>
      <filter id="bnzckynwha">
        <feColorMatrix
          in="SourceGraphic"
          values="0 0 0 0 0.866667 0 0 0 0 0.866667 0 0 0 0 0.866667 0 0 0 1.000000 0"
        />
      </filter>
    </defs>
    <g fill="none" fillRule="evenodd">
      <g>
        <g
          filter="url(#bnzckynwha)"
          transform="translate(-671 -301) translate(500 191)"
        >
          <g>
            <path
              fill="#000"
              fillRule="nonzero"
              d="M59.999 54h-9c-1.656 0-3-1.343-3-3s1.344-3 3-3h8.858c6.62.03 12.034-5.27 12.141-11.89.057-8.067-6.198-10.84-9.883-12.097-1.116-.38-1.904-1.38-2.012-2.554l-.153-1.623c-.673-7.694-7.023-13.652-14.744-13.834-7.002-.081-10.68 4.017-13.06 7.025-.715.89-1.876 1.296-2.99 1.044-1.285-.367-2.615-.557-3.951-.565-4.773.168-8.584 4.032-8.687 8.806l-.047 1.956c-.025 1.2-.766 2.268-1.882 2.71C10.7 28.5 5.76 30.967 6.012 38.014c.251 5.603 4.88 10.01 10.489 9.986H27c1.656 0 3 1.343 3 3s-1.344 3-3 3H16.5C8.563 54.004 1.749 48.352.285 40.55-1.18 32.75 3.12 25.012 10.52 22.137c.101-4.466 2.19-8.653 5.698-11.419 3.507-2.766 8.066-3.822 12.432-2.879C34.002 1.181 42.854-1.568 51.035.886c8.18 2.453 14.059 9.62 14.864 18.124 8.3 2.877 13.31 11.328 11.849 19.99-1.46 8.663-8.964 15.005-17.75 15zm-32.72-14.417l10.483-14.961c.28-.404.738-.644 1.229-.644.49 0 .95.24 1.228.644l10.483 14.96c.331.467.378 1.078.12 1.588s-.777.837-1.348.847H42V72c0 1.657-1.343 3-3 3s-3-1.343-3-3V42.017h-7.492c-.571-.01-1.09-.336-1.348-.847-.258-.51-.212-1.121.12-1.587z"
              transform="translate(171 110)"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
);
